<template>
  <div id="frameAdmin">
    <iframe :src="baseUrl + $store.state.iframeUrl"
            id="iframeBox"
            frameborder="0"
            scrolling="auto"
            :height="iframeHeight"
            style="width: 100%;"
    ></iframe>
  </div>
</template>

<script>
import {iframeBaseUrlAdmin} from '@/http/baseUrl';
export default {
  name: 'frameAdmin',
  data () {
    return {
      iframeHeight: 0,
      baseUrl: iframeBaseUrlAdmin + '/#'
    };
  },
  created () {
    this.setContentDOMHeight();
  },
  methods: {
    setContentDOMHeight () {
      this.iframeHeight = document.body.clientHeight - 85;
    }
  }
};
</script>

<style lang="scss" scoped>
#iframeBox{overflow-y: auto;}
</style>



// WEBPACK FOOTER //
// src/components/frame/admin.vue